
import { Navigate } from 'react-router-dom';
import { ProtectedRouteProps } from 'types';
import { HasPermission } from 'utils/CheckPermissions';
export const RestrictedRoute = ({ pageKey, required, children, redirectPath }: ProtectedRouteProps) => {
 
  const permissions = HasPermission(pageKey, required);
  if (!permissions) {
    
    return <Navigate to={redirectPath} replace />;
  }

  return <>{children}</>;
};









